const { createContext, useState, useContext } = require("react");

const ShowKanbanContext = createContext();
function ShowKanbanProvider(props) {
	const [showKanban, setShowKanban] = useState(false);
	const values = { showKanban, setShowKanban };
	return (
		<ShowKanbanContext.Provider value={values}>
			{props.children}
		</ShowKanbanContext.Provider>
	);
}
function useShowKanban() {
	const context = useContext(ShowKanbanContext);
	if (typeof context === "undefined")
		throw new Error("useShowKanban must be used within ShowKanbanProvider");
	return context;
}
export { useShowKanban, ShowKanbanProvider };
